import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '《名师•名著•创新写作》';

const route: RouteConfig = {
  path: '/20190121MSMZWriting',
  name: 'MSMZWriting',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'First',
      component: () => import('./First.vue'),
      name: 'First',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: 'MSMZWritingRules',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Uploading',
      component: () => import('./Uploading.vue'),
      name: 'MSMZWritingUploading',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: 'MSMZWritingDetail',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
